import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ErrorPage } from '../modules/error-page';
export var Forbidden = function () {
    var t = useTranslation().t;
    return (_jsx(ErrorPage, { code: 403, title: t('forbiddenPage.title'), decription: t('forbiddenPage.description'), comment: t('forbiddenPage.comment') }));
};
